import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'DELIVERY_APMS',
    itemActionName: 'DELIVERY_APM',
});
